export default class ZendeskHelp {
  constructor(selector) {
    this.selector = document.querySelector(selector);

    this.init();
  }

  init() {
    this.isInitialized = true;

    if (!this.selector) {
      this.isInitialized = false;

      return;
    }

    this.bindEvents();
  }

  bindEvents() {
      const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
              const id = entry.target.getAttribute('id');

              if (entry.isIntersecting) {
                this.activeItem(id);
              }
          });
      }, { rootMargin: '0% 0% -70% 0%' });

      this.selector.querySelectorAll('.help__sections__section').forEach((selection) => {
          observer.observe(selection);
      });

      document.querySelectorAll('.help__sections__toc li a').forEach((el) => {
          el.addEventListener('click', (evt) => {
              evt.preventDefault();
              const id = el.getAttribute('href');
              this.selector.querySelector(id).scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'start' });
              setTimeout(() => {
                this.activeItem(id.substring(1, id.length));
              }, 500);
          });
      });
  }

  // eslint-disable-next-line class-methods-use-this
  activeItem(id) {
      document.querySelectorAll('.help__sections__toc li a').forEach((el) => el.classList.remove('active'));
      document.querySelector(`a[href="#${id}"]`).classList.add('active');
  }
}
